<template>
    <div class="peribox">
        <div class="perititle">
            <div>MC Lead</div>
            <div class="periicons">
                <i class="far fa-sync-alt" @click="refresh"></i>
            </div>
        </div>
        <table class="peritable">
            <tbody>
                <tr>
                    <th>Column</th>
                    <th>Lead Raw</th>
                    <th>Lead</th>
                </tr>
                <tr v-for="c in appColumns">
                    <th>{{ c }}</th>
                    <td v-if="app_raw">{{ app_raw[c] }}</td>
                    <td>{{ app ? app[c] : '' }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
    props: [
        'mc_app_raw_id'
    ],
    data() {
        
        let appColumns = [
            'id',
            'driver_id',
            'date',
            'validation',
            'validation_all',
            'name',
            'phone_id',
            'phone_redacted',
            'email_id',
            'email_redacted',
            'zip_code',
            'cdl_a',
            'cdl_b',
            'cdl_c',
            'cdl_a_months_driven',
            'cdl_xp',
            'ip',
            'user_agent',
            'user_language',
            'country',
            'sms_optin',
            'original_referrer',
            'entry_point',
            'paid_media_source',
            'trsource',
            'utm_source',
            'utm_medium',
            'utm_content',
            'utm_campaign',
            'app_submit_page'
        ];
        
        return {
            app_raw: null,
            app: null,
            appColumns: appColumns
        };
    },
    methods: {
        refresh() {
            axios.get(url(`mc/test/app-raw/${this.mc_app_raw_id}`))
            .then((response) => {
                this.app_raw = response.data.app_raw;
                this.app = response.data.app;
            });
        }
    },
    mounted() {
        this.refresh();
    }
}
</script>
